conciergeService.$inject = [
  '$rootScope'
];

export default function conciergeService($rootScope) {
  class ConciergeService {
    sendMessage(text, autosend) { //eslint-disable-line
      text = text || '';
      autosend = autosend || false;

      $rootScope.$broadcast('new-concierge-message', {
        text: text,
        autosend: autosend
      });
    }
  }

  return new ConciergeService();
}



// WEBPACK FOOTER //
// ./src/services/conciergeService.js